import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03d754ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fy-video" }

import api from '@/api/fyApi';
import VideoPlayer from '@/views/components/VideoPlayer.vue';
import { computed, onMounted, reactive, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  props: {
    dataPoster: null,
    dataUrl: null,
    dataMovid: null,
    dataUrlid: null
  },
  setup(__props: any) {

const props = __props as {
    dataPoster: string,
    dataUrl: string,
    dataMovid: string,
    dataUrlid: string
}


const state = reactive({
    url: ''
})
const url = computed(() => {
    if (props.dataUrl) {
        if (props.dataUrl.indexOf('://') > 0) {
            return props.dataUrl
        } else {
            return `https://yuedu-api.sanmanuela.net/v1/tools/getvideo?vid=` + props.dataUrl
        }
    } else {
        return state.url
    }
})
watch(() => props.dataUrlid, checkUrl)
onMounted(checkUrl)
async function checkUrl() {
    if (props.dataMovid && props.dataUrlid) {
        let r = await api.getMovieResourceUrl(props.dataMovid, props.dataUrlid, 1)
        state.url = r.url
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(url))
      ? (_openBlock(), _createBlock(VideoPlayer, {
          key: 0,
          url: _unref(url),
          poster: __props.dataPoster
        }, null, 8, ["url", "poster"]))
      : _createCommentVNode("", true)
  ]))
}
}

})